'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Rules.Constants', []).constant('StrategyConstants', {
  PANEL_TYPE: {
    OPTIMIZATION: 'optimization',
    ALERTS: 'alert'
  },
  RuleType: {
    CUSTOM: 'custom',
    QUICK: 'quick',
    READONLY: 'readonly'
  },
  RuleStructureType: {
    LEVEL: 'specifyLevel',
    TEMPLATE: 'useTemplate'
  },
  StrategyType: {
    CUSTOM: 'custom',
    TEMPLATE: 'template',
    CLASS_CLOSURE: 'classClosure',
    ALLOCATION_AUTH_AVAIL: 'allocationAuthAvail',
    READONLY: 'readonly'
  },
  ACTION: 'action',
  CONDITION: 'condition',
  DROP_DOWN_DATA: {
    RULE_STATUS: [{
      label: 'Active',
      domain: 'active'
    }, {
      label: 'Inactive',
      domain: 'inactive'
    }],
    userOversaleRisk: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
    curtainControlIndicators: ['MOVABLE', 'FIXED', 'FROZEN', 'OPTIMAL'],
    yesno: [{
      dropdownVisibleValue: 'YES',
      value: 'true'
    }, {
      dropdownVisibleValue: 'NO',
      value: 'false'
    }],
    comFareRangeTypes: ['FARE', 'INDEX'],
    comFareMatchRuleTypes: [{
      dropdownVisibleValue: 'LOWEST FARE',
      value: 'LOWEST'
    }, {
      dropdownVisibleValue: 'AVERAGE FARE',
      value: 'AVERAGE'
    }, {
      dropdownVisibleValue: 'CLOSEST TIME',
      value: 'CLOSEST'
    }],
    urdFunctionTypeOptions: ['MIN', 'MAX', 'AVG'],
    segmentTypes: [{
      dropdownVisibleValue: 'Both',
      value: 0
    }, {
      dropdownVisibleValue: 'Local',
      value: 1
    }, {
      dropdownVisibleValue: 'Connecting',
      value: 2
    }]
  },
  Quantifiers: ['AND', 'OR'],
  CLASS_CLOSURE: {
    LEVEL: 'LegClass',
    BASIS: 'classClosure',
    CLASS_NAME_FIELD: 'legClass.className',
    LOAD_FACTOR_FIELD: 'legCabin.currentLoadFactor',
    DTD_FIELD: 'legCabin.departureDTD'
  },
  ALLOCATION_AUTH_AVAIL: {
    LEVEL: 'LegClass',
    BASIS: 'allocationAuthAvail',
    CLASS_NAME_FIELD: 'legClass.className',
    ALLOCATION_TYPE_FIELD: 'legClass.allocationType',
    MIN_ALLOCATION_FIELD: 'legClass.minAllocation',
    MAX_ALLOCATION_FIELD: 'legClass.maxAllocation',
    HARD_OVERRIDE_TYPE_FIELD: 'legClass.hardOverrideType',
    HARD_OVERRIDE_MIN_VALUE_FIELD: 'legClass.hardOverrideMinValue',
    HARD_OVERRIDE_MAX_VALUE_FIELD: 'legClass.hardOverrideMaxValue',
    LINK_TYPE_FIELD: 'legClass.linkType',
    LINK_VALUE_FIELD: 'legClass.linkValue'
  },
  FlowType: ['FlowType.MAPPED', 'FlowType.REGULAR'],
  FlowTypeDisplayedNames: {
    "default": [{
      name: 'Regular',
      value: 'FlowType.REGULAR'
    }, {
      name: 'Mapped',
      value: 'FlowType.MAPPED'
    }],
    MarketDemandClassGroup: [{
      name: 'Regular',
      value: 'FlowType.REGULAR'
    }, {
      name: 'Mapped',
      value: 'FlowType.MAPPED'
    }, {
      name: 'Both',
      value: 'FlowType.BOTH'
    }]
  },
  DefaultFlowType: {
    "default": 'FlowType.REGULAR',
    MarketDemandClassGroup: 'FlowType.BOTH'
  },
  MAX_SELECTABLE_OPERANDS_DATA: 50,
  ERROR_MESSAGES: {
    SINGLE: 'Please correct invalid field',
    SINGLE_MISSING: 'Please correct missing field',
    MULTIPLE: 'Please correct all invalid fields.',
    MULTIPLE_WITH_MISSING: 'Please correct/complete all invalid/required fields.',
    SAVING: 'Saving error',
    EFFECTIVE_DATE: 'Please check effective day start is before effective day end.',
    MISSING_ACTIONS: 'Please specify Actions.',
    INCOMPLETE_PC: 'Primary Conditions are not completed.',
    INCOMPLETE_SC: 'Secondary Conditions are not completed.',
    INCOMPLETE_SA: 'Actions are not completed.',
    INCOMPLETE_LC: 'Link Criteria conditions are not completed.',
    OPERAND_DATA_OVER_THRESHOLD: 'The quantity of selected items exceeds threshold for the following criteria: ',
    OVERRIDE_LINK_ERROR_MSG: 'Either Auth Link Override or Avail Link Override can be entered.',
    MIN_MAX_AUTH_AVAIL_ERROR_MSG: 'Either Min/Max Auth or Min/Max Avail can be entered.',
    PERCENTAGE_ALLOCATION_ERROR_MSG: 'Percentage Allocation values must be between 0 and 100.',
    ALLOCATION_ERROR_MSG: 'All three Allocation attributes: Min, Max and Type are required.',
    ALLOCATION_MIN_MAX_ERROR: 'Max allocation should be greater than min allocation.',
    AUTH_MIN_MAX_ERROR: 'Max authorization should be greater than min authorization.',
    AVAIL_MIN_MAX_ERROR: 'Max availability should be greater than min availability.',
    INCOMPLETE_CONDITIONS: 'Conditions are not completed.',
    INCOMPLETE_ACTIONS: 'Actions are not completed.',
    STRATEGY_DUPLICATES: 'Duplicated Conditions: ',
    PRIMARY_DUPLICATES: 'Duplicated Conditions in primary criteria: ',
    SECONDARY_DUPLICATES: 'Duplicated Conditions in secondary criteria: ',
    LINK_DUPLICATES: 'Duplicated Conditions in link criteria: '
  },
  CONFIRMATION_MESSAGES: {
    CONDITIONS_EMPTY: 'conditions-empty',
    DATE_LOCATION_EMPTY: 'date-location-empty',
    FLOW_TYPE: {
      STRATEGIES_SELECTED: 'strategies-selected',
      CONDITIONS_FILLED: 'conditions-filled',
      CONDITIONS_CUSTOM: 'conditions-custom',
      STRATEGY: 'strategy'
    }
  },
  WHAT_IF_STATUS: {
    FINISHED: 'FINISHED',
    PROCESSING: 'PROCESSING',
    ERROR: 'ERROR'
  }
});